var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"desc_cell"},[_c('div',{staticClass:"text_head"},[_vm._v("注:")]),_c('div',[_vm._t("desc"),_c('span',[_vm._v(_vm._s(_vm.content))])],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }